import { createSvgIcon } from '@mui/material';

export const AmericanExpressIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19243_22621)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#E5F1FA'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.2681 8.34556H42.1845L40.5728 12.9709L38.8908 8.34556H35.7373V15.5475L32.5136 8.34556H29.9208L26.6971 15.7038H28.9395L29.5702 14.2323H32.9341L33.5648 15.7038H37.7696V10.588L39.6617 15.7038H41.4136L43.3058 10.588V15.7038H45.2681V16.8251H42.675L40.5728 19.1377L38.4003 16.8251H29.5003V24.1834H38.3303L40.5026 21.8007L42.675 24.1834H45.2681V25.0942H42.1845L40.5026 23.2723L38.8206 25.0942H28.379V16.6849H25.0151L29.2199 7.22412H33.2845L34.7561 10.4478V7.22412H39.8019L40.6428 9.67695L41.4838 7.22412H45.2681V8.34556ZM45.2681 18.4368L43.3759 20.4691L45.2681 22.5014V24.1834L41.8342 20.4691L45.2681 16.8251V18.4368ZM35.7373 24.1834V22.4314H31.5326V21.3102H35.6671V19.6282H31.5326V18.507H35.7373V16.8251L39.2412 20.4691L35.7373 24.1834ZM30.2009 12.6203L31.1822 10.2377L32.1633 12.6203H30.2009Z'
        fill='#006FCF'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19243_22621'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19243_22621'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19243_22621'
          result='effect2_dropShadow_19243_22621'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19243_22621'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'AmericanExpressIcon',
);
